'use client';

import { Button } from '@/components/ui/buttons/Button';
import { logger } from '@/utils/loggerUtils';
import { useAuthentication } from '@vimond/features/authentication';
import { getEnvVar } from '@vimond/utils/env';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import VippsLogoImage from '../../assets/brand.png';

type VippsSignInButtonProps = {
  onSignInError: (message: string) => void;
};

export const VippsSignInButton = ({
  onSignInError,
}: VippsSignInButtonProps) => {
  const { signInWithVipps } = useAuthentication();
  const { t } = useTranslation('translation');

  if (!(getEnvVar('NEXT_PUBLIC_VIPPS_LOGIN_ENABLED') === 'true')) {
    return null;
  }

  const handleVippsSignIn = async () => {
    try {
      await signInWithVipps?.();
    } catch (err) {
      logger.error('Vipps sign in failed:', err);
      onSignInError(
        t('auth.vipps-sign-in-failed', {
          defaultValue: 'Vipps sign in failed. Please try again later.',
        }),
      );
    }
  };

  return (
    <div className="flex justify-center my-4">
      <div className="max-w-xs w-[90%]">
        <Button
          type="button"
          onClick={handleVippsSignIn}
          variant="primary"
          className="!bg-[#FF5B24] hover:!bg-[#E04A13] focus:!ring-[#FF5B24] hover:!ring-[#FF5B24] hover:!border-[#FF5B24] !border-[#FF5B24] focus:!border-[#FF5B24] !outline-none focus:!outline-none hover:!outline-none rounded-[5px] w-full py-2 flex items-center justify-center gap-2"
        >
          {t('auth.login-with-vipps')}
          <Image
            src={VippsLogoImage}
            alt="Vipps Logo"
            className="h-4 mt-1"
            height={16}
            width={64}
          />
        </Button>
      </div>
    </div>
  );
};
